import { Link } from 'react-router-dom';
import '../App.css';
import Header from './Header';
import { Helmet } from 'react-helmet-async';

type DevelopmentDetailLayoutProps = {
  title: string;
  metaDescription: string;
  tagline: string;
  subtitle: string;
  children: React.ReactNode;
};

function DevelopmentDetailLayout({
  title,
  metaDescription,
  tagline,
  subtitle,
  children,
}: DevelopmentDetailLayoutProps) {
  return (
    <>
      <Helmet>
        <title>
          {title} | Developments | Graham Care
        </title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section development-detail-page">
            <div className="development-detail-container">
              <p className="development-detail-breadcrumb">
                <Link to="/developments" className="nurse-care-link">
                  Developments
                </Link>
              </p>
              <h1>{title}</h1>
              <p className="development-detail-tagline">{tagline}</p>
              <h2 className="development-detail-subtitle">{subtitle}</h2>
              <div className="development-detail-content">{children}</div>
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Graham Care <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Graham Care Ltd, KT15 1HH</p>
                <p>Copyright © Graham Care Ltd</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default DevelopmentDetailLayout;
